module.exports = __webpack_public_path__ + "img/interface-screen-14.78333fa.jpg";